const responseSuppliersList = {

    "payload": [
        {
            "supplierId": '1',
            "nameSupplier": 'IKEA',
            "adviser": 'Carolina Narvaez Rojas',
            "email": "usuario1@example.com",
            "identification": {
                "identificationId": "1",
                "identificationType": "Cédula de ciudadanía",
                "identificationNameShort": "C.C"
            },
            "identificationNumber": "1.122.443.555",
            "contactNumber": "33344333",
            "icon":"https://upload.wikimedia.org/wikipedia/commons/c/c5/Ikea_logo.svg"

        },
        {
            "supplierId": '2',
            "nameSupplier": 'Walmart',
            "adviser": 'Alexandra maria Marchan',
            "email": "usuario2@example.com",
            "identification": {
                "identificationId": "2",
                "identificationType": "Cédula de ciudadanía",
                "identificationNameShort": "C.C"
            },
            "identificationNumber": "1.122.334.455",
            "contactNumber": "35544337",
            "icon": 'https://upload.wikimedia.org/wikipedia/commons/c/ca/Walmart_logo.svg'

        },
        {
            "supplierId": '3',
            "nameSupplier":'LEGO',
            "adviser": 'Michell Castro Mendoza',
            "email": "usuario3@example.com",
            "identification": {
                "identificationId": "2",
                "identificationType": "Cédula de ciudadanía",
                "identificationNameShort": "C.C"
            },
            "identificationNumber": "1.122.334.455",
            "contactNumber": "6765555567",
            "icon": 'https://upload.wikimedia.org/wikipedia/commons/2/24/LEGO_logo.svg'

        }
    ]
}

const responseSuppliersCreate = {

    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Se ha creado exitosamente el proveedor'
        }
    }
}

const responseType = {

    "payload": [
        {
            "identificationId": "1",
            "identificationType": "Cedula",
            "identificationNameShort": "PASS"

        },
        {
            "identificationId": "2",
            "identificationType": "Tarjeta de identidad",
            "identificationNameShort": "PASS"

        },
        {
            "identificationId": "3",
            "identificationType": "Passaporte",
            "identificationNameShort": "PASS"

        }
    ]
};

const responseUpDateSuppliers = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Se ha actualizado exitosamente el proveedor'
        }
    },
};

const responseDeleteSuppliers = {

    "payload": [
        {
            "code": 'U2',
            "message": 'Se ha eliminado exictosamente'
        },
    ]
}

export const service = {
    getSuppliers: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseSuppliersList }), 1000);
    }),
    getSuppliersTypeDocument: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseType }), 1000);
    }),
    postSuppliersCreate: () => new Promise(resolve => {
        setTimeout(() => resolve(responseSuppliersCreate), 2000);
    }),
    upDateSuppliers: () => new Promise(resolve => {
        setTimeout(resolve({ responseUpDateSuppliers }), 2000);
    }),
    getSuppliersDelete: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseDeleteSuppliers }), 1000);
    }),

}